import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            meta: { title: '灵鹿科技' },
            component: () => import('@/pages/home/index.vue'),
        },
        {
            path: '/detail',
            name: 'Detail',
            meta: { title: '灵鹿科技' },
            component: () => import('@/pages/detail/index.vue'),
        },
        {
            path: '/serve',
            name: 'Serve',
            meta: { title: '灵鹿科技' },
            component: () => import('@/pages/home/serve.vue'),
        },
        {
            path: '*',
            meta: { title: '404 - 灵鹿科技' },
            redirect: '/',
        },
    ],
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

export default router;
